import { useLang } from "../../i18n/LanguageContext";

export default function Footer() {
  const { t } = useLang();
  const year = new Date().getFullYear();

  const serviceLinks = [
    { label: t.footer.serviceLinks[0], href: "#services" },
    { label: t.footer.serviceLinks[1], href: "#services" },
    { label: t.footer.serviceLinks[2], href: "#services" },
    { label: t.footer.serviceLinks[3], href: "#services" },
    { label: t.footer.serviceLinks[4], href: "#services" },
    { label: t.footer.serviceLinks[5], href: "#services" },
  ];
  const companyLinks = [
    { label: t.footer.links.about,    href: "#about"    },
    { label: t.footer.links.projects, href: "#projects" },
    { label: t.footer.links.partners, href: "#partners" },
    { label: t.footer.links.contact,  href: "#contact"  },
  ];
  const resourceLinks = [
    { label: t.footer.links.downloads, href: "#downloads" },
  ];

  return (
    <footer className="bg-[#0D0D0E] border-t border-white/5">
      {/* Mega footer grid */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-2 md:grid-cols-4 gap-10">
        {/* Brand */}
        <div className="col-span-2 md:col-span-1 space-y-4">
          <div className="flex items-center gap-2">
            <span className="w-1 h-8 bg-[#F28C18] rounded-sm" />
            <div>
              <div className="text-white font-black text-sm tracking-wider">INTEGRATED SOLUTIONS</div>
              <div className="text-zinc-600 text-[9px] tracking-[0.3em] uppercase">SINCE 1992</div>
            </div>
          </div>
          <p className="text-zinc-600 text-xs leading-relaxed">{t.footer.tagline}</p>
          <div className="flex gap-3 pt-1">
            {[["fa-whatsapp","https://wa.me/201112073337","fab"],["fa-phone","tel:01112073337","fas"],["fa-envelope","mailto:info@integrated-eg.com","fas"]].map(([icon, href, family]) => (
              <a key={href} href={href}
                className="w-8 h-8 rounded-lg bg-white/5 hover:bg-[#F28C18] flex items-center justify-center text-zinc-500 hover:text-black transition-all text-xs">
                <i className={`${family} ${icon}`} />
              </a>
            ))}
          </div>
        </div>

        {/* Services */}
        <div className="space-y-4">
          <div className="text-white font-black text-xs uppercase tracking-widest">{t.footer.services}</div>
          <ul className="space-y-2">
            {serviceLinks.map(l => (
              <li key={l.label}><a href={l.href} className="text-zinc-500 text-xs hover:text-[#F28C18] transition-colors">{l.label}</a></li>
            ))}
          </ul>
        </div>

        {/* Company */}
        <div className="space-y-4">
          <div className="text-white font-black text-xs uppercase tracking-widest">{t.footer.company}</div>
          <ul className="space-y-2">
            {companyLinks.map(l => (
              <li key={l.label}><a href={l.href} className="text-zinc-500 text-xs hover:text-[#F28C18] transition-colors">{l.label}</a></li>
            ))}
          </ul>
        </div>

        {/* Resources + Standards */}
        <div className="space-y-4">
          <div className="text-white font-black text-xs uppercase tracking-widest">{t.footer.resources}</div>
          <ul className="space-y-2">
            {resourceLinks.map(l => (
              <li key={l.label}><a href={l.href} className="text-zinc-500 text-xs hover:text-[#F28C18] transition-colors">{l.label}</a></li>
            ))}
          </ul>
          {/* Standards strip */}
          <div className="pt-4">
            <div className="text-zinc-600 text-[10px] uppercase tracking-widest mb-2">Certifications</div>
            <div className="flex flex-wrap gap-1.5">
              {["UL","FM","NFPA","ISO","CE","API","ASTM"].map(s => (
                <span key={s} className="px-2 py-0.5 bg-white/5 rounded text-[9px] font-black text-zinc-600 uppercase">{s}</span>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/5 py-5 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3 text-[10px] text-zinc-600 font-medium">
        <span>© {year} Integrated Solutions. {t.footer.rights}</span>
        <div className="flex gap-4">
          <a href="#hero" className="hover:text-zinc-400 transition-colors">Back to Top ↑</a>
        </div>
      </div>
    </footer>
  );
}
